<template>
  <v-btn
    v-if="icon"
    fab
    icon
    :small="isIconSize('small')"
    :x-small="isIconSize('x-small')"
    @click="onCopy"
  >
    <v-icon color="appMain" class="icon-outlined">
      {{ copied ? 'check' : 'content_copy' }}
    </v-icon>
  </v-btn>

  <v-btn v-else color="appMain" @click="onCopy">
    {{ copied ? 'Copied!' : 'Copy' }}
  </v-btn>
</template>

<script>
import Vue from 'vue';
import Clipboard from 'v-clipboard';

Vue.use(Clipboard);

export default {
  name: 'CopyBtn',
  props: {
    copy: [String, Number],
    icon: Boolean,
    iconSize: {
      type: String,
      default: 'x-small',
    },
  },
  data() {
    return {
      copied: false,
    };
  },
  methods: {
    isIconSize(size) {
      return this.iconSize === size;
    },
    copyText() {
      const text = this.copy != null ? String(this.copy) : '';

      if (navigator.clipboard && window.isSecureContext) {
        return navigator.clipboard.writeText(text).catch(() => this.fallbackCopy(text));
      }

      return Promise.resolve(this.fallbackCopy(text));
    },
    fallbackCopy(text) {
      return this.$clipboard ? this.$clipboard(text) : false;
    },
    showCopied() {
      this.copied = true;
      setTimeout(() => {
        this.copied = false;
      }, 1000);
    },
    async onCopy() {
      const success = await this.copyText();
      if (success) {
        this.showCopied();
      }
    },
  },
};
</script>
